import _ from "lodash";
import {
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_DP,
} from "Constants/stringConstants";

export const stepListMap = [
  {
    value: "myp_project_year_group_select",
    label: "project:select_project_and_year_group",
    curriculumProgram: [CURRICULUM_TYPE_MYP],
  },
  {
    value: "dp_project_year_group_select",
    label: "project:select_project_or_assessment_and_year_group",
    curriculumProgram: [CURRICULUM_TYPE_DP],
  },
  {
    value: "deadline_details",
    label: "project:deadline_details",
    curriculumProgram: [CURRICULUM_TYPE_MYP, CURRICULUM_TYPE_DP],
  },
];

export const getStepListMap = ({ curriculumProgram, t }) => {
  return _.map(
    _.filter(stepListMap, ({ curriculumProgram: program }) =>
      _.includes(program, curriculumProgram)
    ),
    item => {
      return { ...item, label: t(item.label) };
    }
  );
};
